import tempMeeApi from '../../../apis/tempMee';

/**
 * Fetches posting details from the API
 *
 * @param {import('../types/PostingDetails.parameters').IGetPostingDetailsPayload} payload - Request payload
 * @returns {Promise<import('../types/PostingDetails.api').IGetPostingDetailsApiResponse>} Posting details API response
 */
export const getPostingDetails = async ({ postingId }) => {
  const response = await tempMeeApi.get(`/posting-service/admin/postings/${postingId}`);

  return response.data;
};
